import { AssinaturaEtapaPerfil } from 'eddydata-lib';
import { BaseResourceModel } from '../../models/base-resource.model';
import { Orgao } from './orgao.model';

export class PerfilAssinatura extends BaseResourceModel {

  constructor(
    public id?: number,
    public nome?: string,
    public orgao?: Orgao,
    public assinatura_etapa_perfil?: AssinaturaEtapaPerfil[]
  ) {
    super();
  }

  static converteJson(json: any): PerfilAssinatura {
    return Object.assign(new PerfilAssinatura(), json);
  }
}
